import Box from '@mui/material/Box'
import { EnvBasedStyles, getMode } from '../../../utils/env'

type TLogoTag = {
  label?: string
  color?: string
  top?: number
  right?: number
}

export const LogoTag = ({ label, color, top, right }: TLogoTag) => {
  const envBasedStyling = EnvBasedStyles[getMode()]

  return (
    <Box
      sx={{
        background: color || '#ff8829',
        color: 'white',
        minWidth: 20,
        position: 'absolute',
        top: top || 5,
        right: right || -3,
        borderRadius: '4px',
        fontSize: 11,
        padding: '1px 4px',
      }}
    >
      {label}
    </Box>
  )
}
